import { render, staticRenderFns } from "./StructureSection.vue?vue&type=template&id=76534100&scoped=true&"
import script from "./StructureSection.vue?vue&type=script&lang=js&"
export * from "./StructureSection.vue?vue&type=script&lang=js&"
import style0 from "./StructureSection.vue?vue&type=style&index=0&id=76534100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76534100",
  null
  
)

export default component.exports